import type { CreativeLabelOverride } from '../models/labelEdit.types'

import { stripLabelFieldPrefix } from './labelSchema'

export type LabelOverrideMap = ReadonlyMap<string, ReadonlyMap<string, CreativeLabelOverride>>

export const EMPTY_LABEL_OVERRIDE_MAP: LabelOverrideMap = new Map()

function assetKey(assetId: string): string {
  return assetId.trim().toLowerCase()
}

export function buildLabelOverrideMap(rows: readonly CreativeLabelOverride[]): LabelOverrideMap {
  const byAsset = new Map<string, Map<string, CreativeLabelOverride>>()
  for (const row of rows) {
    const key = assetKey(row.asset_id)
    if (!key) continue
    const labels = byAsset.get(key) ?? new Map<string, CreativeLabelOverride>()
    labels.set(row.label_key, row)
    byAsset.set(key, labels)
  }
  return byAsset
}

export function labelOverrideFor(
  map: LabelOverrideMap,
  creativeId: string,
  field: string,
): CreativeLabelOverride | undefined {
  return map.get(assetKey(creativeId))?.get(stripLabelFieldPrefix(field))
}
